import types from '../constants'
import { findIndexByKeyValue } from './util'

const initialState = {
  playlists: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  children: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  banners: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  articles: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
}

export default function feature(state = {}, action) {
  /** action.id is the catalog id */
  if (action.id) {
    let newState = state[action.id]
      ? state
      : {
        ...state,
        [action.id]: initialState,
      }

    switch (action.type) {
      case types.GET_FEATURE_PLAYLIST_LOADING:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload } },
        }
      case types.GET_FEATURE_PLAYLIST_SUCCESS:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload } },
        }
      case types.GET_FEATURE_PLAYLIST_ERROR:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload } },
        }

      case types.GET_FEATURE_PL_LOADING:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload.playlists } },
        }
      case types.GET_FEATURE_PL_SUCCESS:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload.playlists }, children: { ...action.payload.children } },
        }
      case types.GET_FEATURE_PL_ERROR:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], playlists: { ...newState[action.id].playlists, ...action.payload.playlists } },
        }

      case types.GET_FEATURE_BANNER_LOADING:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], banners: { ...newState[action.id].banners, ...action.payload } },
        }
      case types.GET_FEATURE_BANNER_SUCCESS:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], banners: { ...newState[action.id].banners, ...action.payload } },
        }
      case types.GET_FEATURE_BANNER_ERROR:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], banners: { ...newState[action.id].banners, ...action.payload } },
        }
      case types.GET_FEATURE_ARTICLE_LOADING:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], articles: { ...newState[action.id].articles, ...action.payload } },
        }
      case types.GET_FEATURE_ARTICLE_SUCCESS:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], articles: { ...newState[action.id].articles, ...action.payload } },
        }
      case types.GET_FEATURE_ARTICLE_ERROR:
        return {
          ...newState,
          [action.id]: { ...newState[action.id], articles: { ...newState[action.id].articles, ...action.payload } },
        }
      case types.RESET_FEATURE_VIDEO:
        return { ...newState, [action.id]: initialState }
      // return {
      //   ...newState,
      //   videos: {
      //     meta: {
      //       status: 'loading',
      //     },
      //     data: [],
      //   },
      // }
      case types.FEATURE_VIDEO_REMINDERS_LOADING:
        let currentChild_loading = { ...newState[action.id].children }
        currentChild_loading.data.map((c) => {
          if (c.meta.id === action.payload.playlistId) {
            c.reminders = action.payload.reminders
          }
        })
        return {
          ...newState,
          [action.id]: {
            ...newState[action.id],
            children: { ...currentChild_loading }
          }
        }
      case types.FEATURE_VIDEO_REMINDERS:
        let currentChild = { ...newState[action.id].children }
        currentChild.data.map((c) => {
          if (c.meta.id === action.payload.playlistId) {
            c.reminders = action.payload.reminders
          }
        })
        return {
          ...newState,
          [action.id]: {
            ...newState[action.id],
            children: { ...currentChild }
          }
        }
      default:
        return {
          // ...initialState,
          ...newState,
        }
    }
  } else {
    return { ...state }
  }
}
